import {
    Input,
    Component,
    Output,
    EventEmitter,
    Inject
} from '@angular/core';

import { TOAST_DATA } from '../toastr.service';

@Component({
    selector: 'app-toast-success-cpu-unlock',
    templateUrl: './toast-success-cpu-unlock.component.pug',
    styleUrls: ['./toast-success-cpu-unlock.component.less'],
})
export class ToastSuccessCpuUnlockComponent {
    constructor(
        @Inject(TOAST_DATA) public data: any
    ) {
    }
}
